module.exports = __webpack_public_path__ + "media/emoji_icons/low-34fca68a.svg";